import FavoriteIcon from '@mui/icons-material/Favorite';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import StarIcon from '@mui/icons-material/Star';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ThumbUpOutlineIcon from '@mui/icons-material/ThumbUpOutlined';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import RedeemIcon from '@mui/icons-material/Redeem';
import SendIcon from '@mui/icons-material/Send';

export const getIcons = (data, sx = {}) => {
    console.log("icon" + data)
    if (data === 'heart') {
        return <FavoriteIcon sx={{
            ...sx,
        }}/>;
    } else if (data === 'thumbup') {
        return <ThumbUpIcon sx={{
            ...sx,
        }}/>;
    } else if (data === 'star') {
        return <StarIcon sx={{
            ...sx,
        }}/>;
    } else if (data === 'heart-outline') {
        return <FavoriteBorderIcon sx={{
            ...sx,
        }}/>;
    } else if (data === 'like-outline') {
        return <ThumbUpOutlineIcon sx={{
            ...sx,
        }}/>;
    } else if (data === 'star-outline') {
        return <StarOutlineIcon sx={{
            ...sx,
        }}/>;
    } else if (data === 'star-half') {
        return <StarHalfIcon sx={{
            ...sx,
        }}/>;
    } else if (data === 'redeem') {
        return <RedeemIcon sx={{
            ...sx,
        }}/>;
    } else if (data === 'send') {
        return <SendIcon sx={{
            ...sx,
        }}/>;
    }
}